import { DASHBOARD_SITEHEAD } from "reduxStore/types";
import envJson from "../env.json"; //added end points for cp approval 

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  JWTTOKEN: "token/jwtToken",
  // LOGIN FORGOT API
  LOGIN: "auth/userLogin",
  FORGOTPASSWORD: "/auth/forgotPassword",
  OTPVERIFY: "/auth/otpVerify",
  RESENDOTP: "/auth/resentOtp",
  UPDATEPASSWORD: "/auth/updatePassword",
  CHANGEPASSWORD: "/auth/changePassword",
  VERIFYCURRENTPASSWORD: "/auth/verifyCurrentPassword",
  VERIFYNEWPASSWORD: "/auth/verifyNewPassword",
  FIREBASE_UPDATE: "/auth/firebaseIdUpdate",
  USERPASSWORDSEND: "/auth/userPasswordSend",
  SESSION_STATUS: "/auth/sessionStatus",
  SESSION_PULSE: "/auth/sessionPulse",

  // Permission Module
  PERMISSION_MODULE: "/userManage/getUsermodels",

  // /dashboard
  DASHBOARDDETAILADMIN: "/dashboard/dashboardDetailAdmin",
  DASHBOARDGRAPH: "/dashboard/dashboardGraph",
  DASHBOARDSOURCING:"/dashboard/dashboardDetailSourcing",
  DASHBOARDCLOSING:"/dashboard/dashboardDetailClosing",
  DASHBOARDSCM:"/dashboard/dashboardSCM",
  DASHBOARDSITEHEAD:"/dashboard/dashboardDetailSiteHead",
  DASHBOARDRECEPTIONIST:"/dashboard/dashboardDetailReception",
  DASHBOARDPOSTSALE:"/dashboard/dashboardDetailPostSale",
  DASHBOARDCSTL:"/dashboard/dashboardDetailCstl",


  // USER REGISTER AND ADD USER API BOTH ARE SAME
  REGISTERANDADDUSER: "/auth/userRegister",
  GETUSERLIST: "userManage/getUserList",
  GETUSERDETAIL: "/userManage/getUserDetail",
  GETUSERFILTERDATA: "/userManage/getUserFilterData",
  USERSTATUSUPDATE: "/userManage/userStatusUpdate",
  USERROLEANDPARENTCHANGE: "/userManage/userRoleAndParentChange",
  USERDETAILSFORVISITOR:"/usermanage/getUserDetailForVisitor",

  //EDIT_USER_PROFILE_UPDATE
  EDITUSERPROFILE: "/auth/editUserProfile",
  GETUSERPROFILE: "/auth/getUserProfile",

  // MASTER
  ADDMASTERLIST: "/master/getMasterList",
  CREATEMASTER: "/master/createMaster",
  GETPROPERTYTYPE: "/master/getPropertyType",
  GETCONFIGURATION: "/master/getConfiguration",
  GETAMENITY: "/master/getAmenity",
  GETCITYLIST: "/master/getCityList",

  // ROLE
  GETROLE: "/role/getRoles",
  // POSTROLEDETAIL:"/role/getRoles",
  GETROLEMODULES: "/role/getModules",
  CREATEROLE: "/role/createRole",
  GETMODULESLIST: "/role/getModulesList",
  CREATEMODULE: "/role/createModules",

  // property
  PROPERTYCHECK: "/property/propertyCheck",
  ADDPROPERTY: "/property/addProperty",
  PROPERTYLISTBYAGENT: "/property/getAllProperty",
  PROPERTYLIST: "/property/getMyAllProperty",
  EDITPROPERTY: "/property/editProperty",
  GETPROPERTYDETAIL: "/property/getPropertyDetails",
  GETPROPERTYFILTERDETAIL: "/property/getMyAllProperty",
  // GETPROPERTYFILTERDETAIL: "/property/filterProperty",
  PROPERTYSTATUSUPDATE: "/property/propertyStatusUpdate",
  PROPERTY_GRE_MOBILE_OTP_UPDATE: "/property/propertyGreMobileOtpUpdate",
  PROPERTY_VISITOR_OTP_SMS_CONFIG_GET:
    "/property/propertyVisitorOtpSmsConfigGet",
  PROPERTY_VISITOR_OTP_SMS_CONFIG_UPDATE:
    "/property/propertyVisitorOtpSmsConfigUpdate",
  PROPERTY_VISITOR_OTP_SMS_CONFIG_CLEAR:
    "/property/propertyVisitorOtpSmsConfigClear",
  // Per-property GRE visitor form banner (super admin manage + authenticated fetch).
  PROPERTY_GRE_BANNER_UPDATE: "/property/propertyGreBannerUpdate",
  PROPERTY_GRE_BANNER_REMOVE: "/property/propertyGreBannerRemove",
  GET_GRE_BANNER_IMAGE: "/property/getGreBannerImage",
  PROPERTYCONFIGURATIONLIST: "/property/getPropertyConfigurationsList",
  PROPERTYDOCUMENTDELETE: "/property/propertyDocumentDelete",
  GETPARENTUSERLIST: "/userManage/getParentsUsersList",
  SYNCALLPROJECT: "jwapi/syncAllProjects",
  GETPROPERTYDETAILSJW:"/property/getPropertyDetailsJw",

  // Followup API
  GETFOLLOWUP: "/followup/getFollowUp",
  FOLLOWUPLIST: "/followupStatus/getFollowupList",
  GETFOLLOWUPDETAIL: "/followupStatus/getFollowupDetails",
  UPDATEFOLLOWUP: "/followupStatus/updatefollowup",
  GETLEADTYPE: "/followupStatus/getFollowupList",
  GETSITEVISITTYPE: "/followupStatus/getFollowupList",
  GETBOOKINGTYPE: "/followupStatus/getFollowupList",
  GETREGISTRAIOINTYPE: "/followupStatus/getFollowupList",
  UPDATESTATUS: "/followupStatus/followUpStatusUpdate",
  ADDFOLLOWUP: "/followupStatus/addfollowup",
  //Scheduled Follow up List
  SCHEDULEDFOLLOWUPLIST: "/followupStatus/getScheduleFollowUpList",
  MARKSCHEDULEDFOLLOWUP:"/followupStatus/markScheduledFollowup",

  // Channel Partner API
  CHANNELPARTNERLIST: "/channelPartner/getchannelPartnerList",
  CHANNELPARTNERDETAIL: "/channelPartner/getChannelPartnersDetails",
  CHANNELPARTNERFILTER: "/channelPartner/getFilterChannelPartners",
  CPASSIGNFILTER: "/userManage/getAssignCPList",
  CHANNELPARTNERSTATUS: "/channelPartner/channelPartnerStatusUpdate",
  CPLISTFORSM:"/property/getCpListForPropertyAllocateRequest", 
  CPASSIGNSOURCINGMANAGER:"/userManage/cpAssignSorcingManager",
  // ADDCHANNELPARTNER: "/channelPartner/createChannelPartner",
  SMCHANNELPARTNERSTATUS: "/userManage/smUpdateAssignCpStatus",
  TRANSFERCHANELPARTNERSTATUS: "/channelPartner/transferVisitAgent",
  ADDCHANNELPARTNER: '/channelPartner/createCPwithcompany',
  GETSMLIST: "/channelPartner/getListSourcingManager",
  EDITAGENT: "/channelPartner/editAgent",
  CHECKEMAILMOBILE: "/auth/checkEmailMobile",
  CPCURRENTMAPING: "channelPartner/cpcurrentmaping",
  CHANNELPARTNERAPPROVE: "/channelPartner/approveChannelPartner",
  CPEMPLOYEE: "/channelPartner/getcompanyEmployee",
  ADDCPTOBUCKET:"/userManage/addCpToBucket",
  UPDATE_CP_PROPERTY_SM:"/channelPartner/updateCppropertySM",
  UPDATECHANNELPARTNER:"/channelPartner/updateChannelPartner",
  // Visitor API
  VISITORLIST: "/visit/getVisiterListForAdmin",
  VISITORDETAIL: "/visit/getVisitDetails",
  EDITVISITOR: "/visit/editVisit",
  ADDVISITOR: "/visit/addVisit",
  ADDVISITPROPERTY: "/visit/addVisitProperty",
  BULKIMAGEUPLOAD: "/visit/bulkVisitImageUpload",
  BULKCSVUPLOAD: "/visit/bulkVisitCsvUpload",
  DOWNLOADCSVFILE: "/visit/getBulkVisitCsvFile",
  VISITORMOBILECHECK: "/visit/customerCheckForMobile",
  GET_CP_PROPERTY_FOR_SM: "/property/getCpPropertySM",
  CHECK_VISIT_MOB_AVAILABLE: "/visit/nextVisitCheckMob",
  GETVISITORLIST:"/visit/getVisiterList",
  CHECK_REFERENCE_EXIST:"/visit/checkReferenceNmbrExist",
  SYNCDISPOSITIONREPORT: "/visit/syncDispositionReport",
  SEND_VISITOR_MOBILE_OTP: "/visit/sendVisitorMobileOtp",
  VERIFY_VISITOR_MOBILE_OTP: "/visit/verifyVisitorMobileOtp",
  RESEND_VISITOR_MOBILE_OTP: "/visit/resendVisitorMobileOtp",

  GET_PROPERTY_BASED_SM : "/property/getPropertyBasedSM",
  CP_UNDER_PROPERTY : "/channelPartner/cpUnderProperty",
  GET_PROPERTY_BASED_CM : "/property/getPropertyBasedCM",

  // New Upload
  BULKVISITLIST: "/visit/getBulkVisitList",
  BULKVISITDETAIL: "/visit/getBulkVisitDataDetail",

  // Verify Lead
  BULKVERIFYVISITLIST: "/visit/getBulkVisitVerifyCustomerList",
  VISITORSTATUSUPDATE: "/visit/bulkVisitStatusUpdate",
  VERIFYVISITORDETAIL: "/visit/getBulkVisitVerifyCustomerdetails",
  EDITUNVERIFYCSVVISIT: "/visit/editUnverifyedCsvVisit",

  // Configuration_Setting
  GETCONFIGURATIONSETTINGDETAIL: "/setting/getSettingsDetails",
  UPDATESETTINGDETAIL: "/setting/updateSettingsDetails",
  GETDEFAULTPASSWORD: "/setting/getDefaultPassword",
  UPDATEDEFAULTPASSWORD: "/setting/updateDefaultPassword",
  PREVIEWPASSWORDRESET: "/auth/previewPasswordReset",
  RESETALLUSERPASSWORDS: "/auth/resetAllUserPasswords",
  FORCELOGOUTUSER: "/auth/forceLogoutUser",
  FORCELOGOUTLOGINS: "/auth/forceLogoutLogins",

  // Appointment API
  GETAPPOINTMENTLIST: "/appointment/getAppointmentList",
  GETAPPOINTMENTLISTFORADMIN:"/appointment/getAppointmentListForAdmin",
  GETSITELEADVISIT: "/appointment/getAppointmentList",
  GETCLIENTVISIT: "/appointment/getAppointmentList",
  GETPANDINGSTATUS: "/appointment/getAppointmentList",
  GETCONFIRMSTATUS: "/appointment/getAppointmentList",
  GETCOMPLETESTATUS: "/appointment/getAppointmentList",
  GETAPPOINTMENTDETAIL: "/appointment/getAppointmentDetails",
  EDITAPPOINTMENT: "/appointment/editAppointment",
  ADDAPPOINTMENT: "/appointment/addAppointment",
  CHECKINAPPOINTMENT:"/appointment/checkInAppointmentProperty",
  CLOSEAPPOINTMENT:"/appointment/closeAppointment",
  ALLOCATECLOSINGMANAGERS:"/appointment/appointmentAlocateClosinManager",
  GETAPPOINTMENTLEADSTATUSHISTORY:
    "/appointment/getAppointmentLeadStatusHistory",

  // Site Visit (LMS Integration)
  TRIGGER_WEBHOOK: "/siteVisit/triggerWebhook",
  UPDATE_SITE_VISIT_STATUS: "/siteVisit/updateStatus",
  GET_SITE_VISIT_STATUS_DATA: "/siteVisit/statusData",

  // Support Forum
  GETSUPPORTFORUMLIST: "/supportForum/supportForumList",
  SUPPORTFORMSTATUSUPDATE: "/supportForum/statusUpdateSupportForum",
  ADDSUPPORTFORUM: "/supportForum/addNewSupportForum",
  EDITSUPPORTFORUM: "/supportForum/updateSupportForum",
  SUPPORTFORUMDETAILS: "/supportForum/getSupportForumDetails",

  // Raise Ticket(Support)
  GETRAISETICKETLIST: "/support/getSupportList",
  RAISETICKETDETAILS: "/support/getTicketDetail",
  TICKETSTATUSUPDATE: "/support/ticketStatusUpdate",
  UPDATESUPPORT: "/support/updateSupport",
  REPLYSUPPORTTICKET: "/support/replySupportTicket",
  ADDRAISETICKET: "/support/addSupport",

  //privacy policy

  GETPRIVACYPOLICY: "/privacyPolicy/getPrivacyPolicy",
  UPDATEPRIVACYPOLICY: "/setting/updatePrivacyPolicy",

  // Booking List
  GETBOOKINGLIST: "/booking/getBookingList",
  GETBOOKINGDETAILS: "/booking/getBookingdetails",
  ADDBOOKING:"/booking/addBooking",
  SYNCBOOKINGTOJW: "/booking/syncBookingToJW",

  // Registration List
  GETREGISTRATIONLIST: "/registration/getRegistrationList",
  GETREGISTRATIONDETAILS: "/registration/getRegistrationDetails",

  // Chat Module
  GETALLUSERLISTFORCHAT: "/chat/getAllUserListForChat",
  GETUSERLISTFORCHATING: "/chat/getUserListForChating",
  USERCHATSTATUSUPDATE: "/chat/userChatStatusUpdate",
  GETCPACTIVEPROPERTYLIST: "/chat/getCpActivePropertyList",
  GETPROPERTYUSERLISTFORCHAT: "/chat/getPropertyUserListForChat",
  FIREBASE_DATABASE_URL: envJson.FIREBASE_DATABASE_URL,

  // Report
  GETCONVERSIONFUNNELREPORT: "/report/getConversionFunnelReport",
  GETTEAMPERFORMANCEREPORT: "/report/getTeamPerformanceReport",
  GETTEAMCPPERFORMANCEREPORT: "/report/getTeamCpPerformanceReport",
  GETREPORTPROPERTYLIST: "/report/getReportPropertyList",
  GETREPORTEMPLOYEELIST: "/report/getReportEmployeeList",
  MONTHLYPORPERTYREPORT: "/authreport/monthlyProReport",
  USERACTIVITYREPORT: "/usermanage/getuserActivity",
  GETPDRREPORT:"/authreport/getPdrReport",
  GETSTREPORT:"/authreport/getSTreport",
  GETCTREPORT:"/authreport/getCTreport",
  GETCMREPORT:"/authreport/getCMreport",
  GETSMREPORT:"/authreport/getSMreport",
  GETSHCHREPORT:"/authreport/getSHCHreport",
  GETSCMREPORT:"/authreport/getSCMreport",
  GETSRCHREPORT:"/authreport/getSrcHreport",
  GETBMREPORT:"/authreport/getBMreport",

  // User Announcement
  USERANNOUNCEMENT: "/property/userAnnouncement",

  //Web Report
  ROLEWISEPROJECTREPORT: "/webReport/rolewiseReport",
  PROJECTDETAILSREPORT:"/webReport/projectwiseReport",
  DEPOSITIONREPORT:"/webReport/depositionReport",
  MDOC_AUDIT_LOGS: "/mdoc/auditLogs",
  MDOC_PROPERTIES: "/mdoc/properties",
  MDOC_CLIENT_CONFIG: "/mdoc/clientConfig",
  MDOC_RETRY: "/mdoc/retry",
  // 02/05/2025 New All chanel partner list
  CHANELPARTNERREPORT:"/webReport/getAllChanelPartnerData",

  //Dashboard new 
  DASHBOARDDETAILS:"/dashboards/dashboardDetails",

  //JW
  GET_INVENTORY_JW: "/inventory/fetch_record_details/",

  //closing managers
  CLOSING_MANAGER:"/userManage/getClosingManagerListOnCH",
  CLOSINGMANAGERDETAILS:"/userManage/getUserClosingManagerDetail",

  //sourcing managers
  SOURCINGMANAGER:"/userManage/getUserSourcingManagerList",
  SOURCINGMANAGERDETAILS:"/userManage/getUserSourcingManagerDetail",
  
  //user Appointment
  USERAPPOINTMENTLIST:"/userAppointment/getUSerAppoinmentList",
  USERAPPOINTMENTSTATUSUPDATE:"/userAppointment/userAppointmentStatusUpdate",
  CREATEUSERAPPOINTMENT:"/userAppointment/createUserAppointment",
  EDITUSERAPPOINTMENT:"/userAppointment/editUserAppointment",

  //reports
  USERAPPOINTMENTLISTFORADMIN: "/userAppointment/getUSerAppoinmentListForAdmin",
};
